#import "../../../forms/graphql/fragments/form-fragment.graphql"
#import "./availability-fragment.graphql"
#import "./meeting-validity-issue-fragment.graphql"

fragment MeetingFragment on Meeting {
    id
    modelId
    name
    meetingType
    description
    bookingConfirmationMessage
    htmlUrlPath
    managedByHtmlUrlPath
    durationMinutes
    previewUrl
    minNotice {
        timespan
        unit
    }
    bufferBeforeMins
    bufferAfterMins
    activityType {
        id
        name
    }
    location
    locationType
    creator {
        id
        name
        firstName
        timezone
        schedulerRootMeetingsUrl
        hasCustomizedMeetingUrl
    }
    cohosts {
        id
        name
        firstName
        timezone
    }
    hosts {
        id
        name
        firstName
        timezone
    }
    team {
        id
        name
    }
    availability {
        ...AvailabilityFragment
    }
    publicMeetingLink
    isActive
    form {
        ...FormFragment
    }
    bookings {
        id
    }
    lastBookedTime
    startTimeIntervalMinutes
    numViews
    bookingRate
    sendConfirmationReminder
    sendUpcomingReminder
    sendSoonReminder
    spansTimezones
    validity {
        issues {
            ...MeetingValidityIssueFragment
        }
        isBookable
    }
    embedSnippet
    deletedTime
    allowAdditionalAttendees
    isHidden
    isShowable
    isHideable
    customSlug
    urlSlug
    isManagedTemplate
    isManagedMeeting
    isSevered
    assignments {
        totalCount
        stats {
            assignedUsersCount
            assignedTeamsCount
            severedCount
        }
    }
}
